import { MEGANAV_CONFIGS, CONTENTFUL_NAV_ID } from './constants';
import { type SanitisedMegaNav } from './types';

import { RQ_NAV_CONFIG } from '@/modules/ReactQuery/cacheKeys';
import { type Language } from '@/modules/language/constants';
import { type SupportedLocations } from '@/modules/location/constants';

export function getNavConfigQueryKey(
  language: Language,
  locale: SupportedLocations
) {
  return [RQ_NAV_CONFIG, language, locale] as const;
}

export function getFallbackNavConfig(
  locale: SupportedLocations
): SanitisedMegaNav {
  if (locale === 'us' || locale === 'ca') {
    return MEGANAV_CONFIGS.us();
  }

  if (locale === 'au' || locale === 'nz') {
    return MEGANAV_CONFIGS.au();
  }

  return MEGANAV_CONFIGS.gb();
}

export function getContentfulNavId(
  locale: SupportedLocations,
  language: string
) {
  if (language === 'it') {
    return CONTENTFUL_NAV_ID.it;
  }

  if (language === 'fr') {
    return CONTENTFUL_NAV_ID.fr;
  }

  if (language === 'de') {
    return CONTENTFUL_NAV_ID.de;
  }

  if (locale === 'us') {
    return CONTENTFUL_NAV_ID.us;
  }

  if (locale === 'au') {
    return CONTENTFUL_NAV_ID.au;
  }

  if (locale === 'ie') {
    return CONTENTFUL_NAV_ID.ie;
  }

  if (locale === 'ca') {
    return CONTENTFUL_NAV_ID.ca;
  }

  if (locale === 'nz') {
    return CONTENTFUL_NAV_ID.nz;
  }

  return CONTENTFUL_NAV_ID.gb;
}
